import { gql } from '@apollo/client';

export const CREATE_PAYMENT_HOLD = gql`
  mutation CreatePaymentHold($input: CreateTemporaryPaymentHoldInput!) {
    createTemporaryPaymentHold(input: $input) {
      result
      message
    }
  }
`;

export const mockPaymentHold = {
  createTemporaryPaymentHold: {
    result: 'success',
    message: undefined,
  },
};
